import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { RouterModule } from '@angular/router';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';

@Component({
 selector: 'iho-map-hotel-popup',
 standalone: true,
 imports: [CommonModule, SharedModule, RouterModule],
 templateUrl: './map-hotel-popup.component.html',
 styleUrls: ['./map-hotel-popup.component.scss'],
})
export class MapHotelPopupComponent  {
 @Input() hotelData: any;
 cdnUrl = cdnUrl;
 searchBoxService = inject(SearchBoxService);

 /**
  *
  */
 constructor() {}


 goToPdp(url: string) {
  window.location.href = '/' + url;
 }
}
